import { Entry, IMoleculeModal } from '@belong/types';
import { FImage } from '../image.factory';

interface IEntryMoleculeModal extends Omit<IMoleculeModal, 'image'> {
  image: Entry<any>;
}

export const FMoleculeModal = (data: Entry<IEntryMoleculeModal>): IMoleculeModal => {
  const { image, ...otherFields } = data.fields;
  return {
    image: image && FImage(image),
    ...otherFields
  };
};
